// extracted by mini-css-extract-plugin
module.exports = {"questionsCol":"feedbackRound_questionsCol__1H-pF"};